module.exports = __webpack_public_path__ + "img/aeroland-payment-image-03.8c0f1506.png";